import { render, staticRenderFns } from "./OidcSilentRefresh.vue?vue&type=template&id=60f98c7e"
import script from "./OidcSilentRefresh.vue?vue&type=script&lang=js"
export * from "./OidcSilentRefresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports